export enum ReportTypeEnum {
  InvoiceReport = 1,
  ECM837 = 2,
  Encounter837 = 4
}



// WEBPACK FOOTER //
// ./src/app/core/enums/report-type.enum.ts